import React, { useEffect, useState } from 'react';
import './Bags.css'; 
import { endpoint } from './endpoint';
import BagsListView from "./BagsListView";
import {useNavigate} from "react-router-dom";
import { FaUser,FaBoxOpen,FaShoppingBag,FaCreditCard, FaHistory, FaCog, FaHome, FaQrcode, FaShoppingCart, FaEllipsisV } from 'react-icons/fa';
import {useUser} from "./UserContext";

const Bags = () => {
    const [bags, setBags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
	const {user} = useUser();
    const navigate=useNavigate();
    useEffect(() => {
            if(!user){
				return;
			}
            fetch(`${endpoint}/gymapp/getbags.php?token=${user.token}`)
                .then(response => response.json())
            .then(data => {
                setBags(data.bags);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, [user]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="container">
            <br/><br/><br/><h3 style={{paddingTop:"10px",marginBottom:"-25px",textAlign:"left"}}>Washing Bags<hr/></h3>
			    <button className="d-none"
                        onClick={()=>navigate("/scan")}
                        style={{backgroundColor:"#2f90ab",width:"60px",height:"60px",position:"fixed",bottom:"80px",right:"10px",zIndex:"99999",borderRadius:"100%"}}
                    >
                       <FaQrcode /> <font>Scan</font>
                    </button><br/>
            {bags.length > 0 ? (
                <>
                  <BagsListView bagsStatus={bags} />
                </>
            ) : (
                <p>No bags available.</p>
            )}
        </div>
    );
};

export default Bags;
